import React from 'react';
import { StoreApi } from 'zustand';
import { AuthType } from '@ul/api';

export type SigninNavigationStore = {
    useUnifiedAuthPage: boolean;
    initialLegacyTab?: AuthType;
    initialUsernameValue?: string;
};

export type SigninNavigationStoreFunction = {
    setUseUnifiedAuthPage: (useUnifiedAuthPage: boolean) => void;
    setInitialLegacyTab: (panel: AuthType) => void;
    setInitialUsernameValue: (username: string) => void;
};

export type SigninNavigationContextProps = {
    signInNavigationStore: StoreApi<SigninNavigationStore & SigninNavigationStoreFunction>;
};

const SigninNavigationContext = React.createContext<SigninNavigationContextProps | null>(null);
SigninNavigationContext.displayName = 'SigninNavigationContext';
export { SigninNavigationContext };
